if (window.Promise) {
  console.debug("This browser provides a native Promise. I'm disabling it to force use of core-js to allow onunhandledrejection.")
  delete window.Promise
}

//provide the babel-polyfill in order to ensure things like Symbol are resolved in IE11
require('babel-polyfill');

// https://github.com/JeffreyWay/laravel-mix/issues/436
/*
if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
} */

// fetch() polyfill for making API calls.
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 511
// module chunks = 0